import React from 'react';
import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import { icon as iconTokens } from './primitives/tokens';
import styles from './Icon.module.css';

const icon = cva(styles.base);

export interface IconProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Material Symbol name (e.g. "auto_stories") */
  name: string;
  /** Use filled variant (FILL 1) */
  fill?: boolean;
  /** Font weight (100-700). Default: 200 */
  weight?: number;
  /** Size in pixels. Default: 20 */
  size?: number;
}

export function Icon({
  name,
  fill = false,
  weight = 200,
  size = iconTokens.lg,
  style,
  className = '',
  ...props
}: IconProps) {
  // Default to aria-hidden for decorative icons.
  // If the caller provides aria-label, the icon is meaningful and should be announced.
  const ariaHidden = props['aria-label'] ? undefined : ('true' as const);

  return (
    <span
      className={clsx(icon({ className }), 'material-symbols-outlined')}
      aria-hidden={ariaHidden}
      // eslint-disable-next-line nula-style/no-inline-style -- Material Symbols variation settings are runtime computed from props
      style={{
        fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' 24`,
        fontSize: `${size}px`,
        ...style,
      }}
      {...props}
    >
      {name}
    </span>
  );
}
